import React, { useEffect, useRef } from "react";
import {
  MenuRounded, NotificationsNoneRounded, AddRounded, SearchRounded,
  PersonAddAlt1Rounded, TrackChangesRounded
} from "@mui/icons-material";

export default function FDCHeader({ title, user, onMenu, onNavigate, onSearch, unread }) {
  const search=useRef(null);
  useEffect(()=>{const focus=e=>{if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==="k"){e.preventDefault();search.current?.focus();}};window.addEventListener("keydown",focus);return()=>window.removeEventListener("keydown",focus);},[]);
  return (
    <header className="fdcHeader">
      <div className="fdcHeaderLeft">
        <button className="fdcIconButton fdcMobileMenu" onClick={onMenu} aria-label="Open navigation"><MenuRounded /></button>
        <div>
          <p className="fdcEyebrow">Universe Business Development</p>
          <h1>{title}</h1>
        </div>
      </div>
      <div className="fdcHeaderActions">
        <div className="fdcSearch">
          <SearchRounded />
          <input ref={search} aria-label="Search workspace" placeholder="Search clients, targets..." onKeyDown={e=>{if(e.key==="Enter")onSearch(e.target.value)}}/>
          <kbd>⌘ K</kbd>
        </div>
        <button className="fdcQuickSecondary" onClick={() => onNavigate("targets")}><TrackChangesRounded /> Find target</button>
        <button className="fdcQuickPrimary" onClick={() => onNavigate("onboarding")}><PersonAddAlt1Rounded /> Register client</button>
        <button className="fdcIconButton fdcNotificationButton" aria-label="Notifications" onClick={() => onNavigate("notifications")}>
          <NotificationsNoneRounded />{unread>0&&<span>{unread}</span>}
        </button>
        <button className="fdcHeaderProfile" onClick={() => onNavigate("profile")}>
          <span className="fdcAvatar small">{user.initials}</span>
          <span className="fdcHeaderProfileText"><strong>{user.firstName}</strong><small>{user.level}</small></span>
        </button>
      </div>
    </header>
  );
}
